export const ARCHIVE_MADAD_YEAR_2020 = 2020;
export const ARCHIVE_MADAD_YEAR_2021 = 2021;
export const ARCHIVE_MADAD_YEAR_2022 = 2022;
export const ARCHIVE_MADAD_YEAR_2023 = 2023;
export const ARCHIVE_MADAD_YEAR_2024 = 2024;
export const ARCHIVE_MADAD_YEAR_2025 = 2025;
